import Vue from 'vue'
import Router from 'vue-router'
/**
 * 全站路由配置
 *
 * 建议:
 * 1. 代码中路由统一使用name属性跳转(不使用path属性)
 */
// 开发环境不使用懒加载, 因为懒加载页面太多的话会造成webpack热更新太慢, 所以只有生产环境使用懒加载
const _import = require('./import-' + process.env.NODE_ENV)
/*const page404  = r => require.ensure([], () => r(require('@/views/errorPage/404')))
 const page401  = r => require.ensure([], () => r(require('@/views/errorPage/401')))
 const login  = r => require.ensure([], () => r(require('@/views/login/index')))*/

import Layout from '@/views/layout/Layout'
/**
 * hidden: true                   如果“hidden：true”将不显示在侧边栏（默认为false）
 * alwaysShow: true               设置为true，将始终显示根菜单，无论其子路径长度
 *                                如果没有设置总是显示，在该子路由下不只一个路由
 *                                它将成为嵌套模式，否则不显示根菜单
 * redirect: noredirect           如果设置 `redirect:noredirect`在面包屑中将不会重定向
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']     将控制页面角色（可以设置多个角色）
    title: 'title'               在子菜单和面包屑中显示的名称（推荐设置）
    subtitle:['','']             在子菜单中显示的副标题（可设置多个副标题，对应group（分组序号））
    group:0                      子菜单中分组序号，对应父级的subtitle数组的序号
    icon: 'icon-name'             在侧边栏显示的icon,
    noCache: true                如果为true,该页面将不被缓存(默认为false)
    local:true                   如果为true，进入该页面不清除上一级搜索条件,不设置或false则清除
  }
 **/

export const constantRouterMap = [
  {path: '/login', component: _import('login/index'), name: 'login', hidden: true, meta: {title: '登录'}},
  {path: '/authredirect', component: _import('login/authredirect'), hidden: true},
  {path: '/404', component: _import('errorPage/404'), name: 'page404', hidden: true, meta: {title: '404未找到'}},
  {path: '/401', component: _import('errorPage/401'), name: 'page401', hidden: true, meta: {title: '401无权限'}},
]

export const asyncRouterMap = [
  {
    path: '',
    component: Layout,
    redirect: '/home',
    //alwaysShow:true,
    name: 'home',
    meta: {title: ''},
    children: [
      {
        path: 'home',
        component: _import('home/index'),
        name: 'homeIndex',
        //hidden: true,
        meta: {title: '首页', root: 'home', noCache: true, roles: ['admin','site-index-statistic']}
      }
    ]
  },
  {
    path: '/student',
    component: Layout,
    redirect: '/student/list1',
    name: 'studentManage',
    meta: {title: '学员管理', subtitle: ['待审核学员','学员管理'], roles: ['sudent-earnest','student-primary','student-middle','student-senior','student-foreign','student-coupon-list','student-leave-list']},
    children: [
      {
        path: 'prepayCheckList',
        component: _import('school/student/prepayCheckList'),
        name: 'prepayCheckList',
        meta: {group: 0, title: '定金学员', root: 'studentManage', noCache: false, roles: ['sudent-earnest']}
      },
      {
        path: 'checkList1',
        component: _import('school/student/checkList'),
        name: 'studentCheckList1',
        meta: {group: 0, title: '初级', root: 'studentManage', noCache: false, roles: ['student-primary']}
      },
      {
        path: 'checkList2',
        component: _import('school/student/checkList'),
        name: 'studentCheckList2',
        meta: {group: 0, title: '中级', root: 'studentManage', noCache: false, roles: ['student-middle']}
      },
      {
        path: 'checkList3',
        component: _import('school/student/checkList'),
        name: 'studentCheckList3',
        meta: {group: 0, title: '高级', root: 'studentManage', noCache: false, roles: ['student-senior']}
      },
      {
        path: 'checkList4',
        component: _import('school/student/checkList'),
        name: 'studentCheckList4',
        meta: {group: 0, title: '外语加试', root: 'studentManage', noCache: false, roles: ['student-foreign']}
      },
      {
        path: 'list1',
        component: _import('school/student/list'),
        name: 'studentList1',
        meta: {group: 1, title: '初级', root: 'studentManage', noCache: false, roles: ['student-primary']}
      },
      {
        path: 'list2',
        component: _import('school/student/list'),
        name: 'studentList2',
        meta: {group: 1, title: '中级', root: 'studentManage', noCache: false, roles: ['student-middle']}
      },
      {
        path: 'list3',
        component: _import('school/student/list'),
        name: 'studentList3',
        meta: {group: 1, title: '高级', root: 'studentManage', noCache: false, roles: ['student-senior']}
      },
      {
        path: 'list4',
        component: _import('school/student/list'),
        name: 'studentList4',
        meta: {group: 1, title: '外语加试', root: 'studentManage', noCache: false, roles: ['student-foreign']}
      },
      {
        path: 'coupon',
        component: _import('school/student/coupon'),
        name: 'couponList',
        meta: {group: 1, title: '优惠券发放记录', root: 'studentManage', noCache: true, roles: ['student-coupon-list']}
      },
      {
        path: 'leave',
        component: _import('school/student/leave'),
        name: 'leaveList',
        meta: {group: 1, title: '请假管理', root: 'studentManage', noCache: true, roles: ['student-leave-list']}
      },
      {
        path: 'checkDetail/:id(\\d+)',
        component: _import('school/student/check'),
        name: 'studentCheckDetail',
        hidden: true,
        meta: {title: '学员审核', root: 'studentManage', parent: 'prepayCheckList', noCache: true, roles: ['school-user-audit']}
      },
      {
        path: 'checkDetail1/:id(\\d+)',
        component: _import('school/student/check'),
        name: 'studentCheckDetail1',
        hidden: true,
        meta: {title: '学员审核', root: 'studentManage', parent: 'studentCheckList1', noCache: true, roles: ['school-user-audit']}
      },
      {
        path: 'checkDetail2/:id(\\d+)',
        component: _import('school/student/check'),
        name: 'studentCheckDetail2',
        hidden: true,
        meta: {title: '学员审核', root: 'studentManage', parent: 'studentCheckList2', noCache: true, roles: ['school-user-audit']}
      },
      {
        path: 'checkDetail3/:id(\\d+)',
        component: _import('school/student/check'),
        name: 'studentCheckDetail3',
        hidden: true,
        meta: {title: '学员审核', root: 'studentManage', parent: 'studentCheckList3', noCache: true, roles: ['school-user-audit']}
      },
      {
        path: 'checkDetail4/:id(\\d+)',
        component: _import('school/student/check'),
        name: 'studentCheckDetail4',
        hidden: true,
        meta: {title: '学员审核', root: 'studentManage', parent: 'studentCheckList4', noCache: true, roles: ['school-user-audit']}
      },
      {
        path: 'detail1/:id(\\d+)',
        component: _import('school/student/detail'),
        name: 'studentDetail1',
        hidden: true,
        meta: {title: '学员详情', root: 'studentManage', parent: 'studentList1', noCache: true, roles: ['school-user-detail']}
      },
      {
        path: 'check1/:id(\\d+)',
        component: _import('school/student/check'),
        name: 'studentCheck1',
        hidden: true,
        meta: {title: '学员审核', root: 'studentManage', parent: 'studentList1', noCache: true, roles: ['school-user-audit']}
      },
      {
        path: 'update1/:id(\\d+)',
        component: _import('school/student/edit'),
        name: 'studentUpdate1',
        hidden: true,
        meta: {title: '学员修改', root: 'studentManage', parent: 'studentList1', noCache: true, roles: ['school-user-update']}
      },
      {
        path: 'detail2/:id(\\d+)',
        component: _import('school/student/detail'),
        name: 'studentDetail2',
        hidden: true,
        meta: {title: '学员详情', root: 'studentManage', parent: 'studentList2', noCache: true, roles: ['school-user-detail']}
      },
      {
        path: 'check2/:id(\\d+)',
        component: _import('school/student/check'),
        name: 'studentCheck2',
        hidden: true,
        meta: {title: '学员审核', root: 'studentManage', parent: 'studentList2', noCache: true, roles: ['school-user-audit']}
      },
      {
        path: 'update2/:id(\\d+)',
        component: _import('school/student/edit'),
        name: 'studentUpdate2',
        hidden: true,
        meta: {title: '学员修改', root: 'studentManage', parent: 'studentList2', noCache: true, roles: ['school-user-update']}
      },
      {
        path: 'detail3/:id(\\d+)',
        component: _import('school/student/detail'),
        name: 'studentDetail3',
        hidden: true,
        meta: {title: '学员详情', root: 'studentManage', parent: 'studentList3', noCache: true, roles: ['school-user-detail']}
      },
      {
        path: 'check3/:id(\\d+)',
        component: _import('school/student/check'),
        name: 'studentCheck3',
        hidden: true,
        meta: {title: '学员审核', root: 'studentManage', parent: 'studentList3', noCache: true, roles: ['school-user-audit']}
      },
      {
        path: 'update3/:id(\\d+)',
        component: _import('school/student/edit'),
        name: 'studentUpdate3',
        hidden: true,
        meta: {title: '学员修改', root: 'studentManage', parent: 'studentList3', noCache: true, roles: ['school-user-update']}
      },
      {
        path: 'detail4/:id(\\d+)',
        component: _import('school/student/detail'),
        name: 'studentDetail4',
        hidden: true,
        meta: {title: '学员详情', root: 'studentManage', parent: 'studentList4', noCache: true, roles: ['school-user-detail']}
      },
      {
        path: 'check4/:id(\\d+)',
        component: _import('school/student/check'),
        name: 'studentCheck4',
        hidden: true,
        meta: {title: '学员审核', root: 'studentManage', parent: 'studentList4', noCache: true, roles: ['school-user-audit']}
      },
      {
        path: 'update4/:id(\\d+)',
        component: _import('school/student/edit'),
        name: 'studentUpdate4',
        hidden: true,
        meta: {title: '学员修改', root: 'studentManage', parent: 'studentList4', noCache: true, roles: ['school-user-update']}
      },
    ]
  },
  {
    path: '/school',
    component: Layout,
    redirect: '/school/course/list',
    name: 'schoolManage',
    meta: {title: '学校管理', roles:
        [
          'school-course-list','school-school-list','school-faculty-list', 'school-professional-list','school-language-list', 'school-teacher-list',
          'school-course-user-attendance', 'school-resource-list','school-resource-category-list', 'school-class-list'
        ]
    },
    children: [
      {
        path: 'course/list',
        component: _import('school/course/list'),
        name: 'courseList',
        meta: {title: '课程管理', root: 'schoolManage', noCache: false, roles: ['school-course-list']}
      },
      {
        path: 'course/detail/:id(\\d+)',
        component: _import('school/course/detail'),
        name: 'courseDetail',
        hidden: true,
        meta: {title: '课程详情', root: 'schoolManage', parent: 'courseList', noCache: true, roles: [['school-course-list','school-course-detail']]}
      },
      {
        path: 'school/list',
        component: _import('school/school/list'),
        name: 'schoolList',
        meta: {title: '学校管理', root: 'schoolManage', noCache: false, roles: ['school-school-list']}
      },
      {
        path: 'school/create',
        component: _import('school/school/edit'),
        name: 'schoolCreate',
        hidden: true,
        meta: {title: '新增学校', root: 'schoolManage', parent: 'schoolList', noCache: true, roles: [['school-school-list','school-school-create']]}
      },
      {
        path: 'school/update/:id(\\d+)',
        component: _import('school/school/edit'),
        name: 'schoolUpdate',
        hidden: true,
        meta: {title: '编辑学校', root: 'schoolManage', parent: 'schoolList', noCache: true, roles: [['school-school-list','school-school-update']]}
      },
      {
        path: 'school/department/:id(\\d+)',
        component: _import('school/school/department'),
        name: 'schoolDepartment',
        hidden: true,
        meta: {title: '学校院系', root: 'schoolManage', parent: 'schoolList', noCache: true, roles: [['school-school-list','school-faculty-list']]}
      },
      {
        path: 'school/major/:id(\\d+)',
        component: _import('school/school/major'),
        name: 'schoolMajor',
        hidden: true,
        meta: {title: '学校专业', root: 'schoolManage', parent: 'schoolList', noCache: true, roles: [['school-school-list','school-professional-list']]}
      },
      {
        path: 'school/training/:id(\\d+)',
        component: _import('school/school/training'),
        name: 'schoolTraining',
        hidden: true,
        meta: {title: '培训班', root: 'schoolManage', parent: 'schoolList', noCache: true, roles: [['school-school-list','school-class-list']]}
      },
      {
        path: 'lang/list',
        component: _import('school/lang/list'),
        name: 'langList',
        meta: {title: '语种管理', root: 'schoolManage', noCache: true, roles: ['school-language-list']}
      },
      {
        path: 'teacher/list',
        component: _import('school/teacher/list'),
        name: 'teacherList',
        meta: {title: '科任老师管理', root: 'schoolManage', noCache: true, roles: ['school-teacher-list']}
      },
      {
        path: 'clock/list',
        component: _import('school/clock/list'),
        name: 'clockList',
        meta: {title: '学员考勤管理', root: 'schoolManage', noCache: true, roles: ['school-course-user-attendance']}
      },
      {
        path: 'dataInfo/list',
        component: _import('school/dataInfo/list'),
        name: 'dataInfoList',
        meta: {title: '资料管理', root: 'schoolManage', noCache: true, roles: ['school-resource-list']}
      },
      {
        path: 'dataInfo/categoryList',
        component: _import('school/dataInfo/categoryList'),
        name: 'dataInfoCategoryList',
        meta: {title: '资料分类管理', root: 'schoolManage', noCache: true, roles: ['school-resource-category-list']}
      },
      {
        path: 'trainClass/list',
        component: _import('school/trainClass/list'),
        name: 'trainClassList',
        meta: {title: '培训班管理', root: 'schoolManage', noCache: true, roles: ['school-class-list']}
      },
      {
        path: 'studentRecord/list',
        component: _import('school/studentRecord/list'),
        name: 'studentRecord',
        meta: {title: '学员记录', root: 'schoolManage', noCache: true, roles: ['school-class-list']},
        hidden: true,
      }
    ]
  },
  {
    path: '/ques',
    component: Layout,
    redirect: '/ques/subject/list',
    name: 'questionBankManage',
    meta: {title: '题库管理', roles: ['question-subject-list','question-section-list','question-simulated-list','question-paper-config-list','question-question-list','question-guide-list','question-guide-category-list','question-interpreting-list','question-error-list']},
    children: [
      {
        path: 'subject/list',
        component: _import('quesBank/subject/list'),
        name: 'subjectList',
        meta: {title: '科目管理', root: 'questionBankManage', noCache: true, roles: ['question-subject-list']}
      },
      {
        path: 'chapter/list',
        component: _import('quesBank/chapter/list'),
        name: 'chapterList',
        meta: {title: '章节管理', root: 'questionBankManage', noCache: true, roles: ['question-section-list']}
      },
      {
        path: 'simulated/list',
        component: _import('quesBank/simulated/list'),
        name: 'simulatedList',
        meta: {title: '全真模拟试卷管理', root: 'questionBankManage', noCache: true, roles: ['question-simulated-list']}
      },
      {
        path: 'simulated/detail/:id(\\d+)',
        component: _import('quesBank/question/list'),
        name: 'simulatedDetail',
        hidden: true,
        meta: {title: '试卷详情', root: 'questionBankManage', parent: 'simulatedList', noCache: true, roles: ['question-simulated-list']}
      },
      {
        path: 'simulated/group',
        component: _import('quesBank/group/index'),
        name: 'group',
        meta: {title: '组题试卷管理', root: 'questionBankManage', noCache: true, roles: ['question-paper-config-list']}
      },
      {
        path: 'question/list',
        component: _import('quesBank/question/list'),
        name: 'questionList',
        meta: {title: '题库管理', root: 'questionBankManage', noCache: false, roles: ['question-question-list']}
      },
      {
        path: 'question/create',
        component: _import('quesBank/question/edit'),
        name: 'questionCreate',
        hidden: true,
        meta: {title: '新增题目', root: 'questionBankManage', parent: 'questionList', noCache: true, roles: [['question-question-list','question-question-create']]}
      },
      {
        path: 'question/update/:id(\\d+)',
        component: _import('quesBank/question/edit'),
        name: 'questionUpdate',
        hidden: true,
        meta: {title: '编辑题目', root: 'questionBankManage', parent: 'questionList', noCache: true, roles: [['question-question-list','question-question-update']]}
      },
      {
        path: 'guide/list',
        component: _import('quesBank/guide/list'),
        name: 'guideList',
        meta: {title: '导游200问', root: 'questionBankManage', noCache: false, roles: ['question-guide-list']}
      },
      {
        path: 'guide/create',
        component: _import('quesBank/guide/edit'),
        name: 'guideCreate',
        hidden: true,
        meta: {title: '新增导游200问', root: 'questionBankManage', parent: 'guideList', noCache: true, roles: [['question-guide-list','question-guide-create']]}
      },
      {
        path: 'guide/update/:id(\\d+)',
        component: _import('quesBank/guide/edit'),
        name: 'guideUpdate',
        hidden: true,
        meta: {title: '编辑导游200问', root: 'questionBankManage', parent: 'guideList', noCache: true, roles: [['question-guide-list','question-guide-update']]}
      },
      {
        path: 'guide/classify',
        component: _import('quesBank/guide/classify'),
        name: 'guideClassify',
        meta: {title: '导游200问分类管理', root: 'questionBankManage', noCache: true, roles: ['question-guide-category-list']}
      },
      {
        path: 'interpert/list',
        component: _import('quesBank/interpret/list'),
        name: 'interpretList',
        meta: {title: '口译管理', root: 'questionBankManage', noCache: true, roles: ['question-interpreting-list']}
      },
      {
        path: 'error/list',
        component: _import('quesBank/error/list'),
        name: 'errorList',
        meta: {title: '用户纠错管理', root: 'questionBankManage', noCache: true, roles: ['question-error-list']}
      },
    ]
  },
  {
    path: '/shop',
    component: Layout,
    redirect: '/shop/goods/list',
    name: 'shopManage',
    meta: {title: '商城管理', roles: ['shop-goods-list','shop-freight-template-list','shop-goods-order-list','shop-anchored-order-list']},
    children: [
      {
        path: 'goods/list',
        component: _import('shop/goods/list'),
        name: 'goodsList',
        meta: {title: '商品管理', root: 'shopManage', noCache: false, roles: ['shop-goods-list']}
      },
      {
        path: 'goods/create',
        component: _import('shop/goods/edit'),
        name: 'goodsCreate',
        hidden: true,
        meta: {title: '新增商品', root: 'shopManage', parent: 'goodsList', noCache: true, roles: [['shop-goods-list','shop-goods-create']]}
      },
      {
        path: 'goods/update/:id(\\d+)',
        component: _import('shop/goods/edit'),
        name: 'goodsUpdate',
        hidden: true,
        meta: {title: '编辑商品', root: 'shopManage', parent: 'goodsList', noCache: true, roles: [['shop-goods-list','shop-goods-update']]}
      },
      {
        path: 'order/list',
        component: _import('shop/order/list'),
        name: 'orderList',
        meta: {title: '商品订单管理', root: 'shopManage', noCache: false, roles: ['shop-goods-order-list']}
      },
      {
        path: 'order/detail/:id(\\d+)',
        component: _import('shop/order/detail'),
        name: 'orderDetail',
        hidden: true,
        meta: {title: '订单详情', root: 'shopManage', parent: 'orderList', noCache: true, roles: [['shop-goods-order-list','shop-goods-order-detail']]}
      },
      {
        path: 'template/list',
        component: _import('shop/template/list'),
        name: 'templateList',
        meta: {title: '运费模板管理', root: 'shopManage', noCache: false, roles: ['shop-freight-template-list']}
      },
      {
        path: 'template/create',
        component: _import('shop/template/edit'),
        name: 'templateCreate',
        hidden: true,
        meta: {title: '新增运费模板', root: 'shopManage', parent: 'templateList', noCache: true, roles: [['shop-freight-template-list','shop-freight-template-create']]}
      },
      {
        path: 'template/update/:id(\\d+)',
        component: _import('shop/template/edit'),
        name: 'templateUpdate',
        hidden: true,
        meta: {title: '编辑运费模板', root: 'shopManage', parent: 'templateList', noCache: true, roles: [['shop-freight-template-list','shop-freight-template-update']]}
      },
      {
        path: 'attachedOrder/list',
        component: _import('shop/attachedOrder/list'),
        name: 'attachedOrderList',
        meta: {title: '挂靠订单管理', root: 'shopManage', noCache: true, roles: ['shop-anchored-order-list']}
      }
    ]
  },
  {
    path: '/video',
    component: Layout,
    redirect: '/video/video/type/list',
    name: 'videoManage',
    meta: {title: '视频管理', roles: ['video-live-list','video-written-list','video-interview-list','video-video-type-list']},
    children: [
      {
        path: 'live/list',
        component: _import('video/live/list'),
        name: 'liveList',
        meta: {title: '直播管理', root: 'videoManage', noCache: false, roles: ['video-live-list']}
      },
      {
        path: 'live/create',
        component: _import('video/live/edit'),
        name: 'liveCreate',
        hidden: true,
        meta: {title: '新增直播', root: 'videoManage', parent: 'liveList', noCache: true, roles: [['video-live-list','video-live-create']]}
      },
      {
        path: 'live/update/:id(\\d+)',
        component: _import('video/live/edit'),
        name: 'liveUpdate',
        hidden: true,
        meta: {title: '编辑直播', root: 'videoManage', parent: 'liveList', noCache: true, roles: [['video-live-list','video-live-update']]}
      },
      {
        path: 'video/written/list',
        component: _import('video/video/writtenList'),
        name: 'writtenList',
        meta: {title: '笔试视频管理', root: 'videoManage', noCache: false, roles: ['video-written-list']}
      },
      {
        path: 'video/interview/list',
        component: _import('video/video/interviewList'),
        name: 'interviewList',
        meta: {title: '面试视频管理', root: 'videoManage', noCache: false, roles: ['video-interview-list']}
      },
      {
        path: 'video/create',
        component: _import('video/video/edit'),
        name: 'videoCreate',
        hidden: true,
        meta: {title: '新增视频', root: 'videoManage', parent: ['writtenList','interviewList'], noCache: true,
          roles: [
            ['video-written-list','video-written-create'],
            ['video-interview-list','video-interview-create']
          ]
        }
      },
      {
        path: 'video/update/:id(\\d+)',
        component: _import('video/video/edit'),
        name: 'videoUpdate',
        hidden: true,
        meta: {title: '编辑视频', root: 'videoManage', parent: ['writtenList','interviewList'], noCache: true,
          roles: [
            ['video-written-list','video-written-update'],
            ['video-interview-list','video-interview-update']
          ]
        }
      },
      {
        path: 'video/childList/:id(\\d+)',
        component: _import('video/video/videoChild'),
        name: 'videoChild',
        hidden: true,
        meta: {title: '子目录视频', root: 'videoManage', parent: ['writtenList','interviewList'], noCache: false, roles: [['video-written-list','video-video-child-list']]}
      },
      {
        path: 'video/childCreate',
        component: _import('video/video/childEdit'),
        name: 'childCreate',
        hidden: true,
        meta: {title: '新增子目录视频', root: 'videoManage', parent: 'videoChild', noCache: true, roles: [['video-video-child-list','video-video-child-create']]}
      },
      {
        path: 'video/childUpdate/:id(\\d+)',
        component: _import('video/video/childEdit'),
        name: 'childUpdate',
        hidden: true,
        meta: {title: '编辑子目录视频', root: 'videoManage', parent: 'videoChild', noCache: true, roles: [['video-video-child-list','video-video-child-update']]}
      },
      {
        path: 'video/type/list',
        component: _import('video/videoType/list'),
        name: 'videoTypeList',
        meta: {title: '视频类型管理', root: 'videoManage', noCache: true, roles: ['video-video-type-list']}
      },
    ]
  },
  {
    path: '/score',
    component: Layout,
    redirect: '/score/list',
    name: 'scoreManage',
    meta: {title: '成绩管理', roles: ['user-feedback-list-user','shop-anchored-order-list-user']},
    children: [
      {
        path: 'list',
        component: _import('score/score/list'),
        name: 'scoreList',
        meta: {title: '成绩统计', root: 'scoreManage', noCache: true, roles: ['user-feedback-list-user']}
      },
      {
        path: 'attached/list',
        component: _import('score/attached/list'),
        name: 'attachedList',
        meta: {title: '挂靠统计', root: 'scoreManage', noCache: true, roles: ['shop-anchored-order-list-user']}
      },
      {
        path: 'study/list',
        component: _import('score/study/list'),
        name: 'studyList',
        meta: {title: '学习统计', root: 'scoreManage', noCache: true, roles: ['shop-practice-user-list']}
      }
    ]
  },
  {
    path: '/sys',
    component: Layout,
    redirect: '/sys/admin',
    name:'sysSetup',
    meta:{title:'系统设置',roles: ['sys-admin-get-admin-list','sys-role-get-role-list','site-notification-list','site-banner-list','site-issue-library-list','site-config-list','content-content-list']},
    children: [
      {
        path: 'admin',
        component: _import('sysSet/admin/list'),
        name: 'adminList',
        meta: {title: '管理员账号', root: 'sysSetup', noCache: true, roles: ['sys-admin-get-admin-list']}
      },
      {
        path: 'admin/role',
        component: _import('sysSet/admin/role'),
        name: 'adminRole',
        meta: {title: '管理员权限', root: 'sysSetup', noCache: true, roles: ['sys-role-get-role-list']}
      },
      {
        path: 'admin/permission',
        component: _import('sysSet/admin/permission'),
        name: 'adminPermission',
        hidden: true,
        meta: {title: '权限管理', root: 'sysSetup', parent: 'adminRole', noCache: true, roles: ['sys-permissions-update-role-permissions','sys-permissions-get-permissions-tree','sys-permissions-get-role-permissions']}
      },
      {
        path: 'message',
        component: _import('sysSet/message/list'),
        name: 'messageList',
        meta: {title: '消息管理', root: 'sysSetup', noCache: true, roles: ['site-notification-list']}
      },
      {
        path: 'sendMessage',
        component: _import('sysSet/message/sendMessage'),
        name: 'sendMessage',
        hidden: true,
        meta: {title: '发布通知', root: 'sysSetup', parent: 'messageList', noCache: true, roles: [['site-notification-list','site-notification-send']]}
      },
      {
        path: 'swiper',
        component: _import('sysSet/swiper/list'),
        name: 'swiperList',
        meta: {title: 'banner管理', root: 'sysSetup', noCache: true, roles: ['site-banner-list']}
      },
      {
        path: 'swiper/create',
        component: _import('sysSet/swiper/edit'),
        name: 'swiperCreate',
        hidden: true,
        meta: {title: '新增banner', root: 'sysSetup', parent: 'swiperList', noCache: true, roles: [['site-banner-list','site-banner-create']]}
      },
      {
        path: 'swiper/update/:id(\\d+)',
        component: _import('sysSet/swiper/edit'),
        name: 'swiperUpdate',
        hidden: true,
        meta: {title: '编辑banner', root: 'sysSetup', parent: 'swiperList', noCache: true, roles: [['site-banner-list','site-banner-update']]}
      },
      {
        path: 'question',
        component: _import('sysSet/question/list'),
        name: 'questionList',
        meta: {title: '问题库管理', root: 'sysSetup', noCache: true, roles: ['site-issue-library-list']}
      },
      {
        path: 'sysConfig',
        component: _import('sysSet/sysConfig/index'),
        name: 'sysConfig',
        meta: {title: '系统配置', root: 'sysSetup', noCache: true, roles: ['site-config-list']}
      },
      {
        path: 'content',
        component: _import('sysSet/content/list'),
        name: 'contentList',
        meta: {title: '内容管理', root: 'sysSetup', noCache: true, roles: ['content-content-list']}
      },
      {
        path: 'content/update/:id\?',
        component: _import('sysSet/content/edit'),
        name: 'contentUpdate',
        hidden: true,
        meta: {title: '编辑内容', root: 'sysSetup', parent: 'contentList', noCache: true, roles: [['content-content-list','content-content-update']]}
      }
    ]
  },
]

Vue.use(Router)

export default new Router({
  base:'/admin/',
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js